import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SharedHttp } from '../../../../services/http-client.service';
import { ShopService } from '../../../../services/shop.service';
import { AuthService } from '../../../../services/auth.service';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../../../services/website-theme.service';
/**
 * Confirm Component
 */
let ConfirmShopComponent = class ConfirmShopComponent {
    constructor(httpClient, router, shopService, auth, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.router = router;
        this.shopService = shopService;
        this.auth = auth;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.checkoutData = {};
        this.priceAll = 0;
        this.mobilePhone = '';
        this.token = '';
        this.smsSent = false;
        this.smsError = '';
        this.isErrorSms = false;
        this.smsValidated = false;
        this.products = [];
        this.userData = {};
        this.successColor = '';
        this.secondaryColor = '';
        this.textColor = '';
        this.backColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.themeService.getTheme().subscribe((data) => {
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.backColor = this.themeService.getStyleAttribute('side_menu');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
    }
    ngOnInit() {
        this.userData = JSON.parse(localStorage.getItem('user'));
        this.checkoutData = JSON.parse(localStorage.getItem('checkoutData'));
        this.products = this.shopService.getProducts();
        this.priceAll = this.shopService.calculateAll();
        if (this.products.length < 1) {
            this.router.navigateByUrl('shop');
        }
        if (this.userData) {
            if ((this.checkoutData.mobile === this.userData.mobile) && this.userData.mobile_number_validated === 1) {
                this.smsValidated = true;
            }
        }
    }
    sendSMS() {
        this.httpClient.post('shop/sendmobilevalidationtoken', {
            shop_order_id: this.checkoutData.id
        }).subscribe((result) => {
            this.smsSent = true;
        });
    }
    saveOrder() {
        this.httpClient.post('shop/saveorder', {
            order_id: this.checkoutData.id
        }).subscribe((data) => {
            localStorage.setItem('paymentData', JSON.stringify(data));
            this.router.navigateByUrl('shop/end');
        }, error => console.log(error));
    }
    formatNumber(num) {
        return ((Math.round(num * 100) / 100)).toFixed(2);
    }
    confirmSms() {
        this.httpClient.post('shop/checkmobilevalidationtoken', {
            token: this.token
        }).subscribe((release) => {
            this.smsValidated = true;
            this.isErrorSms = false;
        }, (error) => {
            this.isErrorSms = true;
            this.smsValidated = false;
            this.smsError = error.error;
        });
    }
};
ConfirmShopComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: ShopService },
    { type: AuthService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
ConfirmShopComponent = __decorate([
    Component({
        selector: 'ecd-shop-confirm',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./confirm.component.html")).default
    })
], ConfirmShopComponent);
export { ConfirmShopComponent };
